// import * as React, from "react";
import React, { useEffect, useState, useRef } from "react";

// React Bootstrap
import { Modal, Tab, Nav, Offcanvas } from 'react-bootstrap';

import { Link } from "react-router-dom";

// Import Components
import Header from "../components/HeaderComponent";
import TablePagination from "../components/TablePagination";
import SelectDropdown from "../components/SelectDropdown";
import { config } from "../config";

// Import Images
import managingImage from '../assets/images/manage-crypto-img.svg'
import whiteLogo from "../assets/images/logo-white.svg";

// Import Icons
import chooseWalletIcon1 from '../assets/images/icons/choose-wallet-icon-1.svg'
import chooseWalletIcon2 from '../assets/images/icons/choose-wallet-icon-2.svg'
import chooseWalletArrowIcon from '../assets/images/icons/choose-wallet-arrow-fill-icon.svg'



function ChooseWallet() {
    const [sessionValue, setSessionValue] = useState(false);

    useEffect(() => {
        setSessionValue(sessionStorage.getItem("logedinUser"))
    }, []);
    // Crypto logic to encrypt the session value and pass into the URL
    const [encryptedSessionVlaue, setEncryptedSessionVlaue] = useState('');

    useEffect(() => {
        if (sessionValue) {
            // Simple AES encryption using CryptoJS
            import('crypto-js').then(CryptoJS => {
                const secretKey = config.Encryption_Key; // Replace with a secure key in production
                const ciphertext = CryptoJS.AES.encrypt(sessionValue, secretKey).toString();
                setEncryptedSessionVlaue(encodeURIComponent(ciphertext));
            }).catch(err => console.log('CryptoJS import failed', err));
        }
    }, [sessionValue]);

  

    return (
        <div className='home-page'>
            <Header />
            <section className="sec-banner">
                <div className="container-fluid">
                    <div className="banner-wrapper">
                        <div className="top-notch-wrapper">
                            <span className="top-notch"></span>
                            <a href="#" className="logo">
                                <img src={whiteLogo} alt="logo" />
                            </a>
                        </div>
                        <div className="container">
                            <div className="otc-banner-wrapper">
                                <div className="row">
                                    <div className="col-md-8">
                                        <h3 className="f-24 w-500">Choose Wallet Type</h3>
                                        <p className="f-18 w-500 gray01">Once selected, this option can't be changed. Make sure to choose carefully.</p>
                                    </div>
                                    <div className="col-md-4">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="sec-choose-wallet">
                <div className="container">
                    <div className="choose-wallet-main">
                        <div className="choose-wallet-wrapper">
                            <div className="wallet-card">
                                <div className="card-content">
                                    <div className="icon-wrapper">
                                        <img src={chooseWalletIcon1} alt="icon" />
                                    </div>
                                    <div className="content-wrapper">
                                        <h3 className="f-40 w-500 title">Self-Custody Wallet</h3>
                                        {sessionValue && <>
                                            <p className="f-20 w-500">You manage your private keys and use an air-gapped device for maximum control.</p>
                                            <a
                                                href={`${config.Self_custodium_URL}?e=${encryptedSessionVlaue}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="arrow-icon"
                                            >
                                                <img src={chooseWalletArrowIcon} alt="icon" />
                                            </a></>}
                                    </div>
                                </div>
                            </div>
                            <p className="f-20 w-500 or">OR</p>
                            <div className="wallet-card">
                                <div className="card-content">
                                    <div className="icon-wrapper">
                                        <img src={chooseWalletIcon2} alt="icon" />
                                    </div>
                                    <div className="content-wrapper">
                                        <h3 className="f-40 w-500 title">Custodian Wallet</h3>
                                        {sessionValue && <>
                                            <p className="f-20 w-500">Your private keys are securely managed by an institution with support for recovery, compliance, and institutional-grade security.</p>
                                            <Link to="/home-page" className="arrow-icon"><img src={chooseWalletArrowIcon} alt="icon" /></Link></>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default ChooseWallet
